import React from "react";
import { clsx } from "clsx";
import { CheckOutlined } from "@ant-design/icons";
import { kindTitle, TYPE_CHOICES } from "../useGuidedIntake";
import type { GuidedIntakeState, Topic } from "../useGuidedIntake";
import { INTAKE_TOUR_CONTEXT_ID } from "../intakeTourSteps";
import classes from "../GuidedIntake.module.less";

const ContextRow: React.FC<{ item: Topic }> = ({ item }) => (
    <div className={clsx(classes.contextRow, item.status === "done" && classes.contextRowDone)}>
        <div className={classes.contextRowCheck}>
            {item.status === "done" ? <CheckOutlined /> : null}
        </div>
        <div className={classes.contextRowBody}>
            <div className={classes.contextRowLabel}>{item.label}</div>
            <div className={classes.contextRowHint}>{item.summary || item.hint}</div>
        </div>
    </div>
);

/**
 * The full Context checklist: the wizard's own answers (project type, analysis
 * kind) — pending until picked, echoing the chosen card's title once they are —
 * followed by the kind's conversation topics, ticked off as the chat covers
 * them.
 */
const contextTopics = ({ projectType, analysisKind, topics }: GuidedIntakeState): Topic[] => [
    {
        id: "project-type",
        label: "Project type",
        hint: "Analyze contracts or compare proposals",
        status: projectType != null ? "done" : "pending",
        summary: projectType != null ? TYPE_CHOICES[projectType].title : undefined,
    },
    {
        id: "analysis-kind",
        label: "Analysis kind",
        hint: "The analysis you need",
        status: analysisKind != null ? "done" : "pending",
        summary: analysisKind != null ? kindTitle(analysisKind) : undefined,
    },
    ...topics,
];

export const Context: React.FC<{ state: GuidedIntakeState }> = ({ state }) => (
    <div className={classes.checklistSection} data-tour-id={INTAKE_TOUR_CONTEXT_ID}>
        <div className={classes.sectionLabel}>Context</div>
        {contextTopics(state).map((c) => (
            <ContextRow key={c.id} item={c} />
        ))}
    </div>
);

export default Context;
